module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infobar",
    style: (_vm.infoBar)
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("\n    " + _vm._s(_vm.infoBarMessage) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-default reset-button",
    on: {
      "click": function($event) {
        return _vm.resetScreenWindow()
      }
    }
  }, [_vm._v("\n      Reset screen window\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-default reset-button",
    on: {
      "click": function($event) {
        return _vm.resetScreenPc()
      }
    }
  }, [_vm._v("\n      Reset screen PC\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n    " + _vm._s(_vm.bookieName) + " "), (_vm.bookieName) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.screenName) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fcd58e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoBar.vue
// module id = 239
// module chunks = 1